"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const chat_1 = require("../candidConverters/chat");
const userId_1 = require("../candidConverters/userId");
const option_1 = require("../candidConverters/option");
const timestamp_1 = require("../candidConverters/timestamp");
const CanisterClientFactory_1 = __importDefault(require("../CanisterClientFactory"));
const httpError_1 = require("../../errors/httpError");
function default_1(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const client = CanisterClientFactory_1.default.current.chatsClient;
        const canisterRequest = {
            updated_since: option_1.toCandid(request.updatedSince ? timestamp_1.toCandid(request.updatedSince) : null),
            message_count_for_top_chat: option_1.toCandid(request.messageCountForTopChat)
        };
        let response;
        try {
            response = yield client.get_updates(canisterRequest);
        }
        catch (e) {
            return httpError_1.toHttpError(e);
        }
        if ("Success" in response) {
            const success = response.Success;
            const chats = success.chats.map(chat_1.chatFromCandid);
            let latestUpdateTimestamp = null;
            if (success.chats.length) {
                const latestChat = success.chats[0];
                latestUpdateTimestamp = timestamp_1.fromCandid("Direct" in latestChat
                    ? latestChat.Direct.last_updated
                    : latestChat.Group.last_updated);
            }
            const blockedUsers = success.blocked_users.map(userId_1.fromCandid);
            return {
                kind: "success",
                chats,
                blockedUsers,
                latestUpdateTimestamp,
            };
        }
        else {
            throw new Error("Unrecognised 'get_chats' response");
        }
    });
}
exports.default = default_1;
